import React, { PureComponent, PropTypes } from 'react';

/**
 * Just triggers onSubmit when enter is hit while a field in the form is focused
 */
export default class EnterForm extends PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired
  };

  static defaultProps = {};

  render() {
    const { onSubmit, children, ...rest } = this.props;

    return (
      <form {...rest} onSubmit={e => {
        e.preventDefault();
        onSubmit();
      }}>
        {children}
        <button type="submit" style={{ position: 'absolute', visibility: 'hidden' }}/>
      </form>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/common/components/forms/EnterForm.jsx